import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { parse, ParseResult } from 'papaparse'
import { QFile } from 'quasar'
import { reactive, ref, Ref } from 'vue'

interface IEmits {
  (event: 'parse', data: ParseResult<unknown>): void
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseCSV' },
  __name: 'BaseCSV',
  emits: ["parse"],
  setup(__props, { expose: __expose, emit: __emit }) {


__expose({ pickFiles })
const emit = __emit

const fileRef: Ref<QFile | null> = ref(null)
const state = reactive({ file: {} as File })

function pickFiles() {
  fileRef.value?.pickFiles()
}

function handleCsvInput() {
  if (Object.keys(state.file).length) {
    parse(state.file, {
      header: true,
      skipEmptyLines: true,
      complete(results) {
        emit('parse', results)
      },
    })
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(QFile), {
      ref_key: "fileRef",
      ref: fileRef,
      modelValue: state.file,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((state.file) = $event)),
        handleCsvInput
      ],
      accept: ".csv",
      class: _normalizeClass({ hidden: _ctx.$slots['default'] !== undefined })
    }, null, 8 /* PROPS */, ["modelValue", "class"]),
    _renderSlot(_ctx.$slots, "default", { pickFiles: pickFiles })
  ], 64 /* STABLE_FRAGMENT */))
}
}

})